import {combineReducers} from "redux";
import baseReducer from './Reducers/base'
import gridReducer from './Reducers/grid'
import sidebarReducer from './Reducers/sidebar'
import userReducer from './Reducers/user'
import windowReducer from './Reducers/window'

const reducer = combineReducers({
    base:baseReducer,
    grid: gridReducer,
    sidebar: sidebarReducer,
    user: userReducer,
    window: windowReducer
});

export default reducer
